"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyUtils = void 0;
var CustomCurrencyCodeEnums_1 = require("../../app/types/enum/CustomCurrencyCodeEnums");
var CurrencyEnum_1 = require("../enums/CurrencyEnum");
var currency_codes_1 = __importDefault(require("currency-codes"));
var CurrencyUtils = /** @class */ (function () {
    function CurrencyUtils() {
    }
    CurrencyUtils.format = function (value) {
        var num = value.toString();
        if (!num.includes('.')) {
            return num;
        }
        if (num.includes('e-')) {
            return value.toFixed(parseInt(num.split('e-')[1]) + 1);
        }
        var _v = num.split('.')[1];
        var _i = 0;
        for (var index = 0; index < _v.length; index++) {
            if (parseInt(_v[index]) > 0) {
                _i = index;
                break;
            }
        }
        return value.toFixed(_i + 2);
    };
    CurrencyUtils.symbolName = function (number) {
        //console.log("number",number);
        var _a, _b, _c, _d, _e;
        if (number) {
            switch (number.toString()) {
                case (_a = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.EUR)) === null || _a === void 0 ? void 0 : _a.number:
                    return "EUR";
                case (_b = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.RUB)) === null || _b === void 0 ? void 0 : _b.number:
                    return "RUB";
                case (_c = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.UAH)) === null || _c === void 0 ? void 0 : _c.number:
                    return "UAH";
                case (_d = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.USD)) === null || _d === void 0 ? void 0 : _d.number:
                    return "USD";
                case (_e = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.USD)) === null || _e === void 0 ? void 0 : _e.number:
                    return "USD";
                default:
                    return "";
            }
        }
        return "";
    };
    CurrencyUtils.symbol = function (number) {
        //console.log("number",number);
        var _a, _b, _c, _d;
        if (number) {
            switch (number.toString()) {
                case (_a = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.EUR)) === null || _a === void 0 ? void 0 : _a.number:
                    return "EUR";
                //return "€";
                case (_b = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.RUB)) === null || _b === void 0 ? void 0 : _b.number:
                    return "RUB";
                //return "₽";
                case (_c = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.UAH)) === null || _c === void 0 ? void 0 : _c.number:
                    return "UAH";
                //return "₴";
                case (_d = currency_codes_1.default.code(CurrencyEnum_1.CurrencyEnum.USD)) === null || _d === void 0 ? void 0 : _d.number:
                    return "USD";
                //return "$";
                case CustomCurrencyCodeEnums_1.CustomCurrencyCodeEnums.BINANCE_USDT_CODE.toString():
                    return "USDT";
                //return "₮";
                default:
                    return "";
            }
        }
        return "";
    };
    return CurrencyUtils;
}());
exports.CurrencyUtils = CurrencyUtils;
